module.exports = __webpack_public_path__ + "04_long_gray.265d228c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/04_long_gray.png
// module id = nF9l
// module chunks = 0